/**
 * Helper functions for state management
 */
import { hasActiveFilters, buildFetchParams } from "./filterHelpers";

/**
 * Handles parsed state from URL and applies it to contexts
 * Query parameters take precedence over localStorage values but are NOT saved to localStorage
 * @param {Object} parsed - Parsed state from URL
 * @param {Object} contexts - Object containing filterContext, uiContext, dataContext
 * @returns {Promise<void>}
 */
export const handleParsedState = async (parsed, contexts) => {
  const { filterContext, uiContext, dataContext } = contexts;

  filterContext.updateFilters(parsed.filters, true);
  const hasActive = hasActiveFilters(parsed.filters || {});
  uiContext.updateUIState(
    {
      ...parsed.uiState,
      showAdvancedFilter: hasActive,
    },
    true,
  );

  const params = buildFetchParams(parsed.filters, parsed.uiState.page || 1);
  await dataContext.fetchCatalogueData(params);
};

/**
 * Updates URL state if not currently hydrating
 * @param {Object} filters - Current filter state
 * @param {Object} uiState - Current UI state
 * @param {Function} urlStateService - URL state service instance
 */
export const updateUrlState = (filters, uiState, urlStateService) => {
  if (!urlStateService.getIsHydrating()) {
    const qs = urlStateService.serializeStateToQuery(filters, uiState);
    urlStateService.replaceUrl(qs);
  }
};
